import { forwardRef } from 'react'
import type { CSSProperties, ReactNode } from 'react'

interface CardProps {
  title?: string
  description?: string
  actions?: ReactNode
  children: ReactNode
  className?: string
  /** Pentru dimensiuni care se calculeaza abia in browser (ex. inaltimea ramasa sub antet). */
  style?: CSSProperties
}

export const Card = forwardRef<HTMLElement, CardProps>(function Card(
  { title, description, actions, children, className = '', style },
  ref,
) {
  return (
    <section
      ref={ref}
      className={`rounded-lg border border-b4l-border bg-b4l-surface shadow-sm ${className}`.trim()}
      style={style}
    >
      {(title || actions) && (
        <header className="flex items-start justify-between px-5 pb-3 pt-4">
          <div>
            {title && <h2 className="text-base font-semibold tracking-tight">{title}</h2>}
            {description && <p className="mt-0.5 text-xs text-b4l-text-muted">{description}</p>}
          </div>
          {actions && <div>{actions}</div>}
        </header>
      )}
      <div className="flex min-h-0 flex-1 flex-col px-5 pb-5 pt-1">{children}</div>
    </section>
  )
})
